import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import api from '../../services/api';
import './StatisticsSection.css';

const StatisticsSection = ({ section }) => {
  const [statistics, setStatistics] = useState([]);

  useEffect(() => {
    loadStatistics();
  }, []);

  const loadStatistics = async () => {
    try {
      const response = await api.get('/statistics/');
      setStatistics(response.data);
    } catch (error) {
      console.error('Error loading statistics:', error);
    }
  };

  if (statistics.length === 0) return null;

  return (
    <section className="statistics-section homepage-section bg-primary text-white">
      <Container>
        <h2 className="section-title text-white">{section.title}</h2>
        <Row>
          {statistics.map(stat => (
            <Col key={stat.id} md={4} sm={6} className="mb-4">
              <div className="stat-card text-center">
                {stat.icon && (
                  <div className="stat-icon">
                    <i className={stat.icon}></i>
                  </div>
                )}
                <div className="stat-value">{stat.value}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default StatisticsSection;
